var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.chartData)?_c('line-chart',{attrs:{"chart-data":_vm.chartData,"title":_vm.$t('smi_sri.individual_ielts')}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }